import { GetServerSideProps } from 'next';
import React from 'react';
import Layout from '../../../components/Layout/Layout';
import DigitalStrategyComponent from '../../../components/Services/DigitalStrategy/digitalStrategyComponent';
import { apiRequest } from '../../../components/util/requests/requests';
import { PageMetadata } from '../../../components/util/SeoMetaInformationComponent/SeoMetaInformationComponent';

export interface DigitalStrategyProps {
    pageMetadata?: PageMetadata;
}

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
    const pageMetadata = await apiRequest(
        '/meta-pages?filters[key]=DIGITAL_STRATEGY_PAGE&populate[0]=seo'
    );

    return {
        props: {
            pageMetadata:
                pageMetadata.data && pageMetadata.data.length > 0 ? pageMetadata.data[0] : null,
        },
    };
};

const DigitalStrategy = ({ pageMetadata }: DigitalStrategyProps) => (
    <Layout
        seoMetadata={pageMetadata?.seo}
        defaultMetaTitle={'Noria.no - Services - Digital Strategy'}
    >
        <DigitalStrategyComponent />
    </Layout>
);

export default DigitalStrategy;
